<template>
  <div class="season">
    <card is-large has-outline>
      <form class="form">
        <div class="form__group">
          <text-input label="Name" v-model="form.name" :required="true" />
        </div>
        <div class="form__group">
          <date-input label="Start date" v-model="form.startDate" :required="true" />
        </div>
        <div class="form__group">
          <date-input label="End date" v-model="form.endDate" :required="true" />
        </div>
        <div class="form__group">
          <number-input label="Price in Naira (NGN)" v-model="form.prices.ngn" :required="true" />
        </div>
        <div class="form__group">
          <number-input label="Price in Pounds (GBP)" v-model="form.prices.gbp" :required="true" />
        </div>
        <div class="form__submit">
          <button :disabled="disabled || !formIsValid" @click.prevent="submit">Save</button>
          <button
            v-if="id" @click.prevent="remove" class="is-light" :disabled="disabled">Delete</button>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { DATEFORMAT } from '@/utilities/time';
import TextInput from '@/components/TextInput.vue';
import Card from '@/components/Card.vue';
import NumberInput from '@/components/NumberInput.vue';
import DateInput from '@/components/DateInput.vue';

export default {
  name: 'SeasonForm',
  components: {
    TextInput,
    NumberInput,
    Card,
    DateInput,
  },
  props: {
    id: String,
    name: String,
    startDate: Object,
    prices: Array,
    endDate: Object,
    disabled: Boolean,
  },
  data() {
    return {
      form: {},
    };
  },
  watch: {
    $route() {
      this.setForm();
    },
  },
  methods: {
    setForm() {
      const { $props } = this;
      const { startDate, endDate } = $props;
      this.form = {
        name: $props.name,
        startDate: startDate && dayjs.unix(startDate.seconds).format(DATEFORMAT),
        endDate: endDate && dayjs.unix(endDate.seconds).format(DATEFORMAT),
        prices: {},
      };

      if (!($props.prices && $props.prices.length > 0)) return;

      $props.prices.forEach((price) => {
        const currency = price.currency.toLowerCase();
        const amount = price.amount / 100;
        this.form.prices[currency] = amount;
      });
    },
    submit() {
      const formValue = { ...this.form };
      formValue.startDate = dayjs(this.form.startDate).toDate();
      formValue.endDate = dayjs(this.form.endDate).toDate();
      formValue.prices = this.priceArray;
      this.$emit('submit', formValue);
    },
    remove() {
      this.$emit('remove');
    },
  },
  created() {
    this.setForm();
  },
  computed: {
    ...mapGetters(['getAllSeasons']),
    priceArray() {
      const naira = {
        currency: 'NGN',
        amount: this.form.prices.ngn * 100,
      };
      const pounds = {
        currency: 'GBP',
        amount: this.form.prices.gbp * 100,
      };
      return [naira, pounds];
    },
    formIsValid() {
      const {
        name,
        startDate,
        endDate,
        prices,
      } = this.form;
      const hasPrices = Object.values(prices).some(value => value);
      return name && startDate && endDate && hasPrices;
    },
  },
};
</script>

<style lang="scss" scoped>
.season {
  max-width: 520px;
  margin: 30px auto;
  .form {
    text-align: left;
    &__group + .form__group {
      margin-top: 20px;
    }
    &__submit {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
    }
    .error {
      margin-top: 5px;
      font-size: var(--font-input);
      color: var(--color-link-inactive);
      font-weight: 400;
    }
  }
}
</style>
